// import CanvasScrollClip from 'canvas-scroll-clip'
const CanvasScrollClip = require('canvas-scroll-clip').default

new CanvasScrollClip(document.querySelector('.scroll'), {
  framePath: './imgs/pulsa27e/000.jpg',
  frameCount: 37,
  scrollArea: 1800,
})

// ANIMATION //
const overlayContainer = document.querySelector('.overlay-container')
const animLeger = document.querySelector('.animate-leger')
const animManiable = document.querySelector('.animate-maniable')
const gridMask = document.querySelector('.multi-mask')
const pixelPlume = document.querySelector('.plume')

let observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animated', 'slideOutLeft')
    } else {
      entry.target.classList.remove('animated', 'slideOutLeft')
    }
  })
})

let observer_2 = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animated', 'slideOutRight_1')
    } else {
      entry.target.classList.remove('animated', 'slideOutRight_1')
    }
  })
})

let observer_3 = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animated', 'slideOutRight_2')
    } else {
      entry.target.classList.remove('animated', 'slideOutRight_2')
    }
  })
})

// 10% plus Compact
// let observer_4 = new IntersectionObserver(function (entries) {
//   entries.forEach(function (entry) {
//     entry.target.classList.toggle('animate__slideInDown', entry.isIntersecting)
// if (entry.intersectionRatio > 0) {
//   console.log('ENTRY ClassList : ' + entry.target)
//   entry.target.classList.add('animated', 'animate__slideInDown')
// } else {
//   entry.target.classList.remove('animated', 'animate__slideInDown')
//   console.log('ENTRY ClassList : ' + entry.target)
// }
//   })
// })

// let observer_6 = new IntersectionObserver(function (entries) {
//   entries.forEach(function (entry) {
//     if (entry.intersectionRatio > 0) {
//       console.log('SORTIE ENTRY 6 ClassList : ' + overlayContainer.innerHTML)
//       overlayContainer.classList.remove('animated', 'animate__fadeOutUp')
//       overlayContainer.classList.add('animated', 'animate__fadeOutUp')
//     } else {
//       // overlayContainer.classList.remove(
//       //   'animated',
//       //   'animate__fadeInUp',
//       //   'animate__fadeOutUp'
//       // )
//       // overlayContainer.classList.add('animated', 'animate__fadeInUp')
//       console.log('RETOUR ENTRY 6 ClassList : ' + overlayContainer.innerHTML)
//     }
//   })
// })

// let observer_top = new IntersectionObserver((entries) => {
//   console.log(entries)
//   if (entries[0].boundingClientRect.y < 0) {
//     // overlayContainer.classList.add('animated', 'animate__fadeInUp')
//     console.log('Past 100px!')
//   } else {
//     overlayContainer.classList.remove(
//       'animated',
//       'animate__fadeInUp',
//       'animate__fadeOutUp'
//     )
//     overlayContainer.classList.add('animated', 'animate__fadeInUp')
//     console.log('Not past 100px')
//   }
// })
// observer_top.observe(document.querySelector('#pixel-to-watch'))

// 10%
// const checkDixPourcent = (entries) =>
//   entries.forEach((entry) => {
//     entry.target.classList.toggle('animate__slideInDown', entry.isIntersecting)
//   })

// const ObsDixPourcent = new IntersectionObserver(checkDixPourcent)
// document
//   .querySelectorAll('.compact_10')
//   .forEach((el) => ObsDixPourcent.observe(el))

// ZOOM
const check = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('zoom', entry.isIntersecting)
    // entry.target.classList.toggle('un-hide', entry.isIntersecting)
  })

const Obs = new IntersectionObserver(check)
document.querySelectorAll('.plus_compact_d').forEach((el) => Obs.observe(el))

// LEGER
const checkLe = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('slideOutRight_3', entry.isIntersecting)
  })

const ObsLe = new IntersectionObserver(checkLe)
document.querySelectorAll('.slide-r').forEach((el) => ObsLe.observe(el))

// DROITE
const checkDroite = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('animate__slideInRight', entry.isIntersecting)
  })

const ObsDroite = new IntersectionObserver(checkDroite)
document.querySelectorAll('.droite').forEach((el) => ObsDroite.observe(el))

// GAUCHE
const checkGauche = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('animate__slideInLeft', entry.isIntersecting)
  })

const ObsLeft = new IntersectionObserver(checkGauche)
document.querySelectorAll('.gauche').forEach((el) => ObsLeft.observe(el))

// COMPACT
const checkCompact = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('animate__slideInLeft', entry.isIntersecting)
    animLeger.classList.toggle('animate__slideInRight', entry.isIntersecting)
    animManiable.classList.toggle('animate__slideInLeft', entry.isIntersecting)
  })

const ObsCompact = new IntersectionObserver(checkCompact)
document
  .querySelectorAll('.animate-compact')
  .forEach((el) => ObsCompact.observe(el))

// COMPACT
// const checkCompact = (entries) =>
//   entries.forEach((entry) => {
//     entry.target.classList.toggle('animate__slideInLeft', entry.isIntersecting)
//   })

// const ObsCompact = new IntersectionObserver(checkCompact)
// document
//   .querySelectorAll('.animate-compact')
//   .forEach((el) => ObsCompact.observe(el))

// ZOOMVIDEO
const checkVideo = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('zoom-video', entry.isIntersecting)
  })

const ObsVideo = new IntersectionObserver(checkVideo)
document
  // .querySelectorAll('.pixel-scale-mask')
  .querySelectorAll('.theVideo')
  .forEach((el) => ObsVideo.observe(el))

// 10% PLUS COMPACT
const checkPlusCompact = (entries) =>
  entries.forEach((entry) => {
    entry.target.classList.toggle('animate__pulse', entry.isIntersecting)
  })

const ObsPlusCompact = new IntersectionObserver(checkPlusCompact)
document
  // .querySelectorAll('.pixel-scale-mask')
  .querySelectorAll('.compact_10')
  .forEach((el) => ObsPlusCompact.observe(el))

// MASK MULTIAPP
const checkMulti = (entries) =>
  entries.forEach((entry) => {
    gridMask.classList.toggle('scale-up-br')
    gridMask.classList.toggle('un-hide')
  })
const ObsMulti = new IntersectionObserver(checkMulti)
document
  .querySelectorAll('.pixel-scale-mask')
  .forEach((el) => ObsMulti.observe(el))

// PoidSlideLeft
const checkPoid = (entries) =>
  entries.forEach(
    (entry) => {
      entry.target.classList.toggle(
        'animate__slideInLeft',
        entry.isIntersecting
      )
    },
    { threshold: [0.5] }
  )

const ObsPoid = new IntersectionObserver(checkPoid)

document.querySelectorAll('.poid-l').forEach((el) => ObsPoid.observe(el))

// PoidSlideRight
const checkPoidRight = (entries) =>
  entries.forEach(
    (entry) => {
      entry.target.classList.toggle(
        'animate__slideInRight',
        entry.isIntersecting
      )
    },
    { threshold: [0.5] }
  )

const ObsPoidRight = new IntersectionObserver(checkPoidRight)

document.querySelectorAll('.poid-r').forEach((el) => ObsPoidRight.observe(el))

// slideOutRight_2
const checkSlide = (entries) =>
  entries.forEach(
    (entry) => {
      entry.target.classList.toggle('slideOutRight_2', entry.isIntersecting)
    },
    { threshold: [0.5] }
  )

const ObsSlide = new IntersectionObserver(checkSlide)
document
  .querySelectorAll('.slideOutRight_2')
  .forEach((el) => ObsSlide.observe(el))

// PLUME
const checkPlume = (entries) =>
  entries.forEach((entry) => {
    pixelPlume.classList.toggle('feather', entry.isIntersecting)
    // pixelPlume.classList.add('un-hide', entry.isIntersecting)
    // pixelPlume.classList.remove('hide', entry.isIntersecting)
  })

const ObsPlume = new IntersectionObserver(checkPlume)
document.querySelectorAll('.pixel-plume').forEach((el) => ObsPlume.observe(el))

// Overlay
const checkOverlay = (entries) =>
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      overlayContainer.classList.remove('animate__fadeOutUp')
      overlayContainer.classList.add('animate__fadeInUp', 'animated')
    } else {
      overlayContainer.classList.remove('animate__fadeInUp')
      overlayContainer.classList.add('animate__fadeOutUp', 'hide', 'animated')
    }
    // overlayContainer.classList.toggle(
    //   'animate__slideOutUp',
    //   entry.isIntersecting
    // )
  })

const ObsOverlay = new IntersectionObserver(checkOverlay)
document
  .querySelectorAll('.pixel-to-watch')
  .forEach((el) => ObsOverlay.observe(el))

// observer.observe(document.querySelector('.anim_d'))
// animElements.forEach((element) => {
//   observer.observe(element)
// })

// animElements_2.forEach((element) => {
//   observer_2.observe(element)
// })

// animElements_3.forEach((element) => {
//   observer_3.observe(element)
// })

// animElements_4.forEach((element) => {
//   observer_4.observe(element)
// })
// animElements_6.forEach((element) => {
//   observer_6.observe(element)
// })

// SCROLL TRIGGER
// gsap.registerPlugin(ScrollTrigger)

// gsap.utils.toArray('.panel').forEach((panel, i) => {
//   ScrollTrigger.create({
//     trigger: panel,
//     start: 'top top',
//     pin: true,
//     pinSpacing: false,
//   })
// })

// ScrollTrigger.create({
//   snap: 1 / 15, // snap whole page to the closest section!
// })
